import type { Notify } from "./admin-types";
import { Header, EmptyState, Outcome } from "./AdminPagePrimitives";
import { formatDate } from "./admin-presentation";

import { useAdminAuditWorkspace } from "./useAdminAuditWorkspace";

export function AuditPage({notify}: {notify: Notify}) {
  const { rows } = useAdminAuditWorkspace({notify});
  return (
    <>
      <Header
        eyebrow="Denetim izi"
        title="Güvenlik Kayıtları"
        description="Kritik erişim ve işlem olaylarını değiştirilemez denetim kayıtlarından izleyin."
      />
      <section className="module-card">
        {rows.length ? (
          <div className="data-table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>İşlem</th>
                  <th>Kullanıcı</th>
                  <th>Hedef</th>
                  <th>Sonuç</th>
                  <th>Tarih</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <strong>{row.action}</strong>
                    </td>
                    <td>{row.actor_name ?? "Sistem"}</td>
                    <td>
                      {row.entity_type}
                      {row.entity_id ? ` · ${row.entity_id}` : ""}
                    </td>
                    <td>
                      <Outcome value={row.outcome} />
                    </td>
                    <td>{formatDate(row.occurred_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <EmptyState
            title="Denetim kaydı bulunmuyor"
            description="Kritik kullanıcı ve süreç işlemleri burada kayıt altına alınacak."
          />
        )}
      </section>
    </>
  );
}
